<template>
  <a-row :gutter="20" class="campuses">
    <a-col :span="24">
      <a-card :title="$t('cardTitle.' + (isAdmin ? 'testimonials' : 'yourTestimonials'))" class="style1 testimonial-list">
        <p v-if="empty(testimonialList)" style="text-align: center; font-size: 24px;" class="mb-5">{{ $t('page.campuses.yourLocations.para1') }}</p>
        <a-spin tip="Loading..." :spinning="isLoading">
          <ul>
            <li
              v-for="testimonial in testimonialList"
              :key="testimonial.key"
              @click="selectLocation(testimonial)"
              :class="`${isMobile ? 'mobile' : ''} ${selected === testimonial.id ? 'selected' : ''}`"
            >
              <a href="javascript: void(0);" @click="openVideo(testimonial)" class="d-flex align-items-center">
                <a-icon type="video-camera" />
                <div class="d-flex flex-column ml-2">
                  <!-- <img :src="testimonial.embeded_icon" class="mr-3" />
              <b>{{ testimonial.title }}</b> -->
                  <b>{{ testimonial.name }}</b>
                  <span>{{ testimonial.video_url }}</span>
                </div>
              </a>
              <div>
                <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(testimonial)" placement="topRight" v-if="!testimonial.flagged">
                  <a-button type="danger" class="mr-2">Flag</a-button>
                </a-popconfirm>
                <a-button v-else disabled :class="['btn-disabled']" class="mr-2">Video has been flagged</a-button>
                <a-popconfirm v-if="!testimonial.approved" title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onApprove(testimonial)" placement="topRight">
                  <a-button type="primary">Include</a-button>
                </a-popconfirm>
                <a-button v-else :class="['ant-btn-success']">Include</a-button>
              </div>
            </li>
          </ul>
        </a-spin>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import initZiggeo from '@/services/Ziggeo';
// import LocationService from '@/services/LocationService';
import AdminService from '@/services/AdminService';
import { mapState } from 'vuex';
import { get, map } from 'lodash';
import { empty } from '@/utils';
export default {
  props: {
    campuses: {
      type: Array,
      default: null,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: false,
    isUpdate: false,
    testimonialList: [],
    selected: '',
    testimonial_id: null,
  }),

  // beforeCreate() {
  //   this.form = this.$form.createForm(this, { name: 'validate_other' });
  // },
  computed: {
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    isMobile() {
      return this.settings.isMobileView;
    },
    updateLocationTitle() {
      if (this.isAdmin) {
        return this.$t('cardTitle.churchLocation.' + this.isUpdate ? 'adminUpdate' : 'adminAdd');
      }
      return this.$t('cardTitle.churchLocation.' + this.isUpdate ? 'update' : 'add');
    },
  },
  async mounted() {
    await this.doInitData();
    await initZiggeo();
  },
  methods: {
    empty,
    async doInitData() {
      try {
        this.isLoading = true;
        let resp = await AdminService.shareStory().getAll();
        this.testimonialList = map(resp, (item, index) => ({
          ...item,
          key: index,
        }));
      } catch (error) {
        console.log({ error });
      } finally {
        this.isLoading = false;
      }
    },
    onResetForm() {
      this.isUpdate = false;
      this.form.resetFields();
      this.selected = '';
    },
    selectLocation(record) {
      this.selected = record.id;
      this.isUpdate = true;
      // this.testimonial_id = record.id;
      // if (!this.isDesktop) {
      //   document.getElementById('formLocations').scrollIntoView();
      // }
      // this.$nextTick(() => {
      //   this.form.setFieldsValue({
      //     name: record.name,
      //     address: record.address,
      //     address2: record.address2,
      //     city: record.city,
      //     country: record.country,
      //     zipcode: record.zipcode,
      //     state: record.state,
      //   });
      // });
    },
    // handleSubmit(e) {
    //   e.preventDefault();
    //   this.form.validateFields(async (err, values) => {
    //     if (!err) {
    //       try {
    //         this.isLoading = true;
    //         if (!this.isAdmin) {
    //           await (this.isUpdate ? LocationService.doUpdateLocation({ ...values, testimonial_id: this.testimonial_id }) : LocationService.doAddLocation(values));
    //           await this.doInitData();
    //         } else {
    //           await (this.isUpdate ? AdminService.testimonial.update(this.testimonial_id, values) : LocationService.doAddLocation(values));
    //           this.$emit('onSuccess');
    //         }
    //         this.$notification['success']({
    //           message: 'Location',
    //           description: this.isUpdate ? 'You have successfully updated testimonial!' : 'You have successfully added new testimonial!',
    //         });
    //       } catch (error) {
    //         console.log(error);
    //         this.$notification['error']({
    //           message: error.response.status,
    //           description: get(error, 'response.data.error', error.message),
    //         });
    //       } finally {
    //         this.isLoading = false;
    //       }
    //     }
    //   });
    // },
    openVideo(testimonial) {
      console.log(testimonial);
      if (window.ZiggeoApi.V2.Application.getDefault() == null) {
        // eslint-disable-next-line no-new
        new window.ZiggeoApi.V2.Application({
          token: process.env.VUE_APP_ZIGGEO_AUTH,
          webrtc_streaming_if_necessary: true,
          webrtc_on_mobile: true,
        });
      }
      var popPlayer = new ZiggeoApi.V2.PopupPlayer({
        attrs: {
          width: '80vw',
          height: 'calc(80vw * 0.5625)',
          video: testimonial.video_token,
          theme: 'modern',
          themecolor: 'blue',
        },
      });
      window.popPlayer = popPlayer;
      popPlayer.activate();
    },
    async onDelete(testimonial) {
      try {
        this.isLoading = true;
        const resp = await AdminService.shareStory().flag(testimonial.id);
        console.log({ resp });
        this.$notification['success']({
          message: 'Video has been flagged',
        });
      } catch (error) {
        console.log({ error });
        this.$notification['error']({
          message: 'Flag error',
          description: get(error, 'response.data.error', error.message),
        });
      } finally {
        this.isLoading = false;
      }
    },
    async onApprove(testimonial) {
      try {
        this.isLoading = true;
        const resp = await AdminService.shareStory().approve(testimonial.id);
        console.log({ resp });
        this.$notification['success']({
          message: 'Video will be included in your profile',
        });
      } catch (error) {
        console.log({ error });
        this.$notification['error']({
          message: 'Approve error',
          description: get(error, 'response.data.error', error.message),
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style lang="scss">
.campuses {
  .testimonial-list {
    .ant-card-body {
      padding: 10px;
      height: 540px;
      overflow: auto;
    }
  }
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #6c757d;
      padding: 10px;
      border-radius: 4px;
      margin-bottom: 10px;
      cursor: pointer;
      img {
        max-width: 200px;
      }
      &.mobile {
        flex-direction: column;
        align-items: flex-start;
      }
      &.selected {
        background: rgba(#23c6c8, 0.2);
      }
    }
  }
}
// .ba-popup-helper-overlay-inner {
.ba-popup-helper-overlay-background {
  // width: 80vw;
  // height: calc(80vw * 0.5625);
  // position: relative;
  &::after {
    content: '⤬';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    color: #000;
    padding: 0.5rem 1rem;
    background: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    font-size: 2rem;
    font-weight: 700;
  }
}
.ant-btn-success {
  background-color: #8bc34a;
  border-color: #8bc34a;
  color: #fff;
  cursor: initial !important;
  &:hover,
  &:focus {
    background-color: rgba(#8bc34a, 0.8);
    border-color: rgba(#8bc34a, 0.8);
    color: #fff;
  }
}
.btn-disabled {
  color: #9e9e9e !important;
}
</style>
